export enum packageListTabsTypes {
  upgrade = 'upgrade',
  partner = 'partner',
}
